import { render, staticRenderFns } from "./TreatmentPlanRequestAttachScanModal.vue?vue&type=template&id=64c5a15a&scoped=true&"
import script from "./TreatmentPlanRequestAttachScanModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequestAttachScanModal.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequestAttachScanModal.vue?vue&type=style&index=0&id=64c5a15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5a15a",
  null
  
)

export default component.exports